import { useMemo } from "react";
import DataTable from "../DataTable";

/**
 * Ciudades con costo de envío propio.
 *
 * `min-width: 560px` es el mínimo medido para las cuatro columnas; por debajo
 * de eso el DataTable genérico pasa a tarjeta por registro.
 */
const MIN_WIDTH = 560;

const formatCurrency = (value, currency) => {
  if (value === null || value === undefined) return "—";
  return `${currency || "$"} ${new Intl.NumberFormat("es-CO", {
    minimumFractionDigits: 0,
  }).format(value)}`;
};

export const CityList = ({
  onEdit,
  data,
  isLoading,
  pagination,
  setPagination,
  onFilterChange,
  filterValue,
  onSearch,
  currency,
}) => {
  const columns = useMemo(
    () => [
      {
        header: "Ciudad",
        accessorKey: "name",
        cell: (info) => (
          <span style={{ fontWeight: 600 }}>{info.getValue()}</span>
        ),
      },
      {
        header: "Departamento",
        accessorKey: "provinceName",
        cell: (info) => (
          <span style={{ color: "#5A6187" }}>{info.getValue()}</span>
        ),
      },
      {
        header: "Costo de envío",
        accessorKey: "shippingCost",
        cell: (info) => (
          <span
            style={{ fontWeight: 700, fontVariantNumeric: "tabular-nums" }}
          >
            {formatCurrency(info.getValue(), currency)}
          </span>
        ),
      },
      {
        header: "Acciones",
        accessorKey: "actions",
        // Sin botón de eliminar: no hay endpoint para quitarle el costo propio
        // a una ciudad, y ponerlo en 0 no es lo mismo que borrarlo.
        cell: (info) => (
          <div className="d-flex justify-content-end">
            <button
              type="button"
              className="ui-icon-btn ui-icon-btn--accent"
              title="Editar costo"
              onClick={() => onEdit(info.row.original)}
            >
              <i className="ri-edit-line" />
            </button>
          </div>
        ),
      },
    ],
    [onEdit, currency]
  );

  const filters = (
    <>
      <h3 className="ui-card__title" style={{ marginRight: "auto" }}>
        Ciudades con costo propio
      </h3>

      <span className="ui-search">
        <i className="ri-search-line" />
        <input
          type="text"
          placeholder="Buscar ciudad"
          value={filterValue}
          onChange={(e) => onFilterChange(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onSearch()}
        />
      </span>

      <button type="button" className="ui-btn ui-btn--sm" onClick={onSearch}>
        Buscar
      </button>
    </>
  );

  return (
    <DataTable
      data={data?.data?.cities ?? []}
      columns={columns}
      total={data?.data?.total ?? 0}
      pagination={pagination}
      setPagination={setPagination}
      progressPending={isLoading}
      minWidth={MIN_WIDTH}
      filters={filters}
      emptyMessage="Ninguna ciudad de este país tiene costo propio todavía."
    />
  );
};
